import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { S as SKELETON_VARIANTS } from "./index-BIblv54e.js";
const MockGatsbyLink = forwardRef(({ to, ...props }, ref) => /* @__PURE__ */ jsx("a", { id: "MockGatsbyLink", ref, href: to, ...props }));
const MockNextLink = forwardRef(({ href, ...props }, ref) => /* @__PURE__ */ jsx("a", { id: "MockNextLink", ref, href, ...props }));
const mockSkeletonNavBar = [
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 100,
    height: 37,
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 99,
    height: 37
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 82,
    height: 37,
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 100,
    height: 37
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 122,
    height: 37,
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: 93,
    height: 37
  }
];
const mockSkeletonMarketplace = [
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: "100%",
    height: "100%",
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: "100%",
    height: "100%"
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: "100%",
    height: "100%",
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: "100%",
    height: "100%"
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: "100%",
    height: "100%",
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED,
    width: "100%",
    height: "100%"
  }
];
const mockSkeletonSearchCTA = [
  {
    variant: SKELETON_VARIANTS.ROUNDED_RECT,
    width: 132,
    height: 48,
    sx: { reverseAnimation: true }
  },
  {
    variant: SKELETON_VARIANTS.ROUNDED_RECT,
    width: 138,
    height: 48
  }
];
export {
  MockGatsbyLink as M,
  MockNextLink as a,
  mockSkeletonNavBar as b,
  mockSkeletonSearchCTA as c,
  mockSkeletonMarketplace as m
};
//# sourceMappingURL=mockSkeletons-Dzu6jNn4.js.map
